import type { WidgetDefinition } from '../WidgetDefinition';
import { tradeProWidgetDefinition } from './trade-pro';
import { faArrowsTurnToDots } from '@fortawesome/pro-solid-svg-icons/faArrowsTurnToDots';
import type { TradeProWidgetModel } from '@thinkalpha/ui-types/contracts/workspace';

class TradeProMultiWidgetDefinition implements WidgetDefinition<TradeProWidgetModel, TradeProWidgetModel> {
    type = 'trade-pro-multi' as const;
    nameKey = 'widgets::trade-pro-multi::name' as const;
    roles = ['widgets::trade-pro-multi'];
    icon = faArrowsTurnToDots;
    category = 'widgets::categories::trading' as const;
    defaultDimensions = { h: 0.44, w: 0.4, x: 0.3, y: 0.28 };

    toViewModel = tradeProWidgetDefinition.toViewModel;
    toContractModel = tradeProWidgetDefinition.toContractModel;
}

export const tradeProMultiWidgetDefinition = new TradeProMultiWidgetDefinition();
